import { NgModule } from '@angular/core';
import { AddressSummaryPipe } from './address-summary/address-summary.pipe';
import { ArticleImagesPipe } from './article-images/article-images.pipe';
import { ArticleMainImagePipe } from './article-main-image/article-main-image.pipe';
import { ArticleManufacturerLogoPipe } from './article-manufacturer-logo/article-manufacturer-logo.pipe';
import { ContactListPipe } from './contact-list/contact-list.pipe';
import { CountryListPipe } from './country-list/country-list.pipe';
import { FacetOptionFilterPipe } from './facet-option-filter/facet-option-filter.pipe';
import { FilterListPipe } from './filter-list/filter-list.pipe';
import { GetErrorPipe } from './get-error/get-error.pipe';
import { HasErrorPipe } from './has-error/has-error.pipe';
import { LanguageHumanReadablePipe } from './language-human-readable/language-human-readable.pipe';
import { LanguageListPipe } from './language-list/language-list.pipe';
import { OrderByBooleanPipe } from './order-facet-option-by-boolean/order-by-boolean.pipe';
import { ProductFeaturesPipe } from './product-features/product-features.pipe';
import { ProductImagesPipe } from './product-images/product-images.pipe';
import { ProductMainImagePipe } from './product-main-image/product-main-image.pipe';
import { ProductManufacturerLogoPipe } from './product-manufacturer-logo/product-manufacturer-logo.pipe';
import { RoleHumanReadablePipe } from './role-human-readable/role-human-readable.pipe';
import { RoleListPipe } from './role-list/role-list.pipe';
import { SafeUrlPipe } from './safe-url/safe-url.pipe';
import { ShippingAddressListPipe } from './shipping-address-list/shipping-address-list.pipe';
import { ShippingTypeListPipe } from './shipping-type-list/shipping-type-list.pipe';
import { UrlFilterParamsPipe } from './url-filter-params/url-filter-params.pipe';
import { UrlPathPipe } from './url-path/url-path.pipe';
import { ArticleCountPipe } from './article-count/article-count.pipe';
import { MasonryGridClassPipe } from './masonry/masonry-grid-class.pipe';
import { SelectedUnitQueryParamPipe } from './selected-unit-query-param/selected-unit-query-param.pipe';
import { LabelImagePipe } from './label-image/label-image.pipe';
import { ArticleLabelImagePipe } from './article-label-image/article-label-image.pipe';
import { ArticleFeatureListPipe } from './article-feature-list/article-feature-list.pipe';
import { SteelProcessingItemCheckedPipe } from './steel-processing-item-checked/steel-processing-item-checked.pipe';

const pipes: any[] = [
  GetErrorPipe,
  HasErrorPipe,
  AddressSummaryPipe,
  ShippingAddressListPipe,
  ShippingTypeListPipe,
  CountryListPipe,
  LanguageListPipe,
  RoleListPipe,
  ContactListPipe,
  LanguageHumanReadablePipe,
  RoleHumanReadablePipe,
  UrlPathPipe,
  UrlFilterParamsPipe,
  OrderByBooleanPipe,
  FacetOptionFilterPipe,
  ProductImagesPipe,
  ProductMainImagePipe,
  ArticleMainImagePipe,
  ArticleImagesPipe,
  RoleListPipe,
  SafeUrlPipe,
  FilterListPipe,
  ProductManufacturerLogoPipe,
  ProductFeaturesPipe,
  ArticleManufacturerLogoPipe,
  ArticleCountPipe,
  MasonryGridClassPipe,
  SelectedUnitQueryParamPipe,
  LabelImagePipe,
  ArticleLabelImagePipe,
  ArticleFeatureListPipe,
  SteelProcessingItemCheckedPipe,
];

@NgModule({
  declarations: [pipes, ArticleFeatureListPipe],
  imports: [],
  exports: pipes,
})
export class PipesModule {}
